<template>
    <div class="new-detail">
        <div class="new-body">
            <div class="new-content" v-html="newDetail.content"></div>
            <div class="new-footer">
                <router-link class="to-index" to="/new_list">{{$t("new.news")}}</router-link>
                <!-- <router-link class="to-index" to="/index">{{$t("home")}}</router-link> -->
                <a class="to-index" @click="toTop">{{$t("new.top")}}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { getNewsById } from "@/api/article.js";
export default {
    name: "NewDetail",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            nid: this.$route.query.nid,
            newDetail: {}
        };
    },
    watch: {
        $route(to, from) {
            // console.log(to, from);
            location.reload();
        }
    },
    mounted() {
        this.getNewDetail();
    },
    methods: {
        getNewDetail() {
            getNewsById({ id: this.nid })
                .then(res => {
                    if (res && res.status == 200) {
                        this.newDetail = res.data[1];
                    }
                })
                .catch(msg => {
                    console.log(msg);
                });
        },
        toTop() {
            document.documentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
};
</script>

<style lang="scss">
@keyframes active_maker {
    0% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(20px);
    }
    100% {
        transform: translateY(0px);
    }
}
.new-detail {
    width: 100%;
    padding: 80px 0;
    display: flex;
    justify-content: center;
    .new-body {
        width: 80%;
        background: #ccbfab;
        padding: 20px 40px;
        border-radius: 10px;
        box-shadow: 10px 10px 5px #555;
        .new-content {
            overflow: hidden;
            p,
            span {
                background: none !important;
            }
            img {
                max-width: 100% !important;
                height: auto !important;
            }
        }
        .new-footer {
            display: flex;
            justify-content: center;
            margin-top: 100px;
            .to-index {
                display: block;
                color: #fff;
                padding: 5px 30px;
                margin: 0 10px;
                background: url($cdnPrefix+"/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
            }
        }
    }
}
// 适配小屏
@media screen and (max-width: 768px) {
    .new-detail {
        padding: 40px 0;
        .new-body {
            width: 90%;
            padding: 20px;
            .new-footer {
                margin-top: 30px;
                .to-index {
                    padding: 5px 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/New_detail.vue